import { useEffect, useState, useCallback } from 'react'

const useGeolocation = ({
  enableHighAccuracy,
  maximumAge,
  timeout
} = {}) => {
  const [coordinates, setCoordinates] = useState({
    latitude: null,
    longitude: null,
    timestamp: null,
    error: null
  })

  const updateCoordinates = useCallback(({
    coords = {},
    timestamp
  }) => {
    const {
      latitude,
      longitude
    } = coords

    setCoordinates({
      latitude,
      longitude,
      timestamp,
      error: null
    })
  }, [])

  const setError = useCallback(error => {
    setCoordinates({
      latitude: null,
      longitude: null,
      timestamp: null,
      error
    })
  }, [])

  useEffect(() => {
    let watchId

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(updateCoordinates, setError)
      watchId = navigator.geolocation.watchPosition(updateCoordinates, setError, {
        enableHighAccuracy,
        maximumAge,
        timeout
      })
    }

    return () => {
      if (watchId) {
        navigator.geolocation.clearWatch(watchId)
      }
    }
  }, [enableHighAccuracy, maximumAge, setError, timeout, updateCoordinates])

  return coordinates
}

export default useGeolocation
